import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';

type Props = {
  relatedVideos: any
  title: string
}

function RelatedVideos({
  relatedVideos, title,
}: Props) {
  return (
    <div className="border-t border-chdGreen-light">
      <p className="uppercase text-chdGreen-light font-bold text-[24px] leading-[26.5px] tracking-[2.4px] mt-2.5 whitespace-nowrap">{title}</p>
      {relatedVideos.map((item: any) => (
        <div className="mt-10" key={item.id}>
          <Link
            to={item.slug}
            className="text-white hover:text-chdGreen-light"
          >
            <GatsbyImage
              image={getImage(item?.thumbnailMediaStandard?.gatsbyImageData)!}
              alt={item.title}
            />
            <p className="mt-2 text-lg font-normal text-[24px] leading-[29.5px] whitespace-pre-wrap opacity-90">{item.title}</p>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default RelatedVideos;
